require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./likwidacja-spolek.json") })
        }
      }, "path---likwidacja-spolek");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---likwidacja-spolek!./.cache/json/likwidacja-spolek.json
// module id = 520
// module chunks = 231608221292675